import EvStationIcon from "@mui/icons-material/EvStation";
import Tooltip from "@mui/material/Tooltip";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import React from "react";
import { useTranslation } from "react-i18next";

export function ChargingCell(props: GridRenderCellParams) {
  const getStyle = (value: number) => {
    switch (value) {
      case 0: // Not charging
        return "action";
      case 1: // AC
        return "success";
      case 2: // DC
        return "success";
      case 3:
        // Charge Interrupt
        return "error";
      default: // No data
        return "disabled";
    }
  };
  const { t } = useTranslation();

  const translations = [
    t("faultOverview.doesntCharge"),
    t("faultOverview.charges") + " AC",
    t("faultOverview.charges") + " DC",
    t("faultOverview.chargeInterrupt"),
  ];
  if (props.value === -1) return <></>;
  const style: "action" | "success" | "disabled" | "error" = getStyle(props.value);

  return (
    <Tooltip style={{ height: "100%" }} title={translations[props.value]}>
      <EvStationIcon color={style} fontSize="large" />
    </Tooltip>
  );
}
